import { LOAD_AUTHENTICATIONTOKEN_ERROR, LOAD_AUTHENTICATIONTOKEN_LOADING, LOAD_AUTHENTICATIONTOKEN_SUCCESS } from "../actions/actionAuthentication";
const initialState = {
    token: [],
    loading: false,
    authenticationError: ''
};

function reducerAuthenticationToken(state = initialState, action) {
    switch (action.type) {
        case LOAD_AUTHENTICATIONTOKEN_LOADING: {
            return {
                ...state,
                loading: true,
                authenticationError: ''
            };
        }
        case LOAD_AUTHENTICATIONTOKEN_SUCCESS: {
            return {
                ...state,
                token: action.token,
                loading: false
            }
        }
        case LOAD_AUTHENTICATIONTOKEN_ERROR: {
            return {
                ...state,
                loading: false,
                authenticationError: action.error
            };
        }
        default: {
            return state;
        }
    }
}

export default reducerAuthenticationToken;
